import { render, staticRenderFns } from "./GraficoMortalidadePeriodoFechamento.vue?vue&type=template&id=367d34c8&"
import script from "./GraficoMortalidadePeriodoFechamento.vue?vue&type=script&lang=js&"
export * from "./GraficoMortalidadePeriodoFechamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports